import React, { useEffect, useState } from 'react';
import { Modal, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { db } from "../../firebase/config";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

function ProductosModal({ openModal, handleCloseModal, handleEdit }) {
  const [productos, setProductos] = useState([]);

  useEffect(() => {
    const fetchProductos = async () => {
      const querySnapshot = await getDocs(collection(db, "productos"));
      const productosData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProductos(productosData);
    };

    if (openModal) {
      fetchProductos();
    }
  }, [openModal]);

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "productos", id));
    setProductos(productos.filter(p => p.id !== id));
  };

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <h3 style={{ fontWeight: 600 }}>Productos</h3>
        <TableContainer component={Paper}>
          <Table aria-label="tabla productos">
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Categoría</TableCell>
                <TableCell>Precio</TableCell>
                <TableCell>Stock</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productos.map((producto) => (
                <TableRow key={producto.id}>
                  <TableCell>{producto.nombre}</TableCell>
                  <TableCell>{producto.categoria}</TableCell>
                  <TableCell>{producto.precio}</TableCell>
                  <TableCell>{producto.stock}</TableCell>
                  <TableCell>{producto.descripcion}</TableCell>
                  <TableCell>
                    <Button onClick={() => handleEdit(producto)}>
                      <EditIcon />
                    </Button>
                    <Button onClick={() => handleDelete(producto.id)} sx={{ color: 'red' }}>
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Button onClick={handleCloseModal} variant="outlined" sx={{ mt: 2 }}>
          Cerrar
        </Button>
      </Box>
    </Modal>
  );
}

export default ProductosModal;